import * as React from 'react';

function SvgShowPasswordOn(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3.333C4.054 3.333.214 9.474.145 9.586a.667.667 0 00-.034.781c.011.024 3.235 6.3 9.889 6.3 6.626 0 9.845-6.215 9.884-6.29a.667.667 0 00-.029-.79c-.069-.113-3.91-6.254-9.855-6.254zm0 2a4.667 4.667 0 110 9.334 4.667 4.667 0 010-9.334zM10 8a2 2 0 100 4 2 2 0 000-4z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgShowPasswordOn;
